<template>
  <modal
    name="modal--vendor-select"
    transition="nice-modal-fade"
    :click-to-close="true"
    :width="400"
    :height="'auto'"
    :adaptive="true"
    :reset="true"
    :scrollable="true"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    class="py-10"
  >
    <div class="flex flex-col text-black h-full bg-white overflow-hidden w-full justify-between p-4">
      <div class="text-center text-4xl mb-2 font-extralight tracking-tight">
        Create Order
      </div>
      <div class="text-xl mb-4 font-extralight tracking-tight leading-tight text-gray-600">
        Select vendors to order from.
      </div>

      <div class="mb-4">
        <div
          v-for="vendorId in vendorsActive"
          :key="vendorId"
          class="flex items-center justify-between py-3 px-4 mb-2 rounded-lg cursor-pointer transition-colors"
          :class="selectedVendors.includes(vendorId)
            ? 'bg-gray-300'
            : 'bg-gray-100 hover:bg-gray-200'"
          @click="toggleVendor(vendorId)"
        >
          <span class="text-xl tracking-tight">{{ vendorName(vendorId) }}</span>
          <span
            v-if="selectedVendors.includes(vendorId)"
            class="w-6 h-6 rounded-full bg-red-700 flex items-center justify-center flex-shrink-0"
          >
            <i class="fas fa-check text-white text-xs" />
          </span>
        </div>
      </div>

      <div class="flex flex-row justify-between mt-2">
        <s-button
          color="white"
          color-hover="gray"
          :shade="200"
          :shade-hover="200"
          text-color="gray"
          :text-shade="900"
          @click="cancel"
        >
          <span class="font-normal">Cancel</span>
        </s-button>
        <s-button
          :color="selectedVendors.length > 0 ? 'red' : 'gray'"
          :shade="selectedVendors.length > 0 ? 700 : 200"
          :shade-hover="selectedVendors.length > 0 ? 800 : 200"
          :text-color="selectedVendors.length > 0 ? 'white' : 'gray-500'"
          @click="createOrder"
        >
          <span class="font-normal">Create Order</span>
        </s-button>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex'
import SButton from '@/components/Button.vue'

export default {
  name: 'ModalVendorSelect',
  components: { SButton },
  data() {
    return {
      selectedVendors: []
    }
  },
  computed: {
    ...mapGetters('storeModule/vendors', ['vendorsActive', 'vendorName']),
    ...mapGetters('storeModule', ['invoicesForVendorIds'])
  },
  methods: {
    beforeOpen() {
      this.selectedVendors = []
    },
    beforeClose() {
      this.selectedVendors = []
    },
    toggleVendor(vendorId) {
      const index = this.selectedVendors.indexOf(vendorId)
      if (index === -1) {
        this.selectedVendors.push(vendorId)
      } else {
        this.selectedVendors.splice(index, 1)
      }
    },
    cancel() {
      this.$modal.hide('modal--vendor-select')
    },
    createOrder() {
      if (!this.selectedVendors.length) return
      const invoices = this.invoicesForVendorIds(this.selectedVendors)
      this.$modal.hide('modal--vendor-select')
      this.$nextTick(() => {
        this.$modal.show('modal--submit-order', {
          isVendorOrder: true,
          invoices
        })
      })
    }
  }
}
</script>
